// 影视示例数据（前端演示用）
// 播放功能仅为界面模拟，未接入真实视频源

export const mediaList = [
  {
    id: 'm01',
    title: '流光之城',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20vertical%20film%20poster%2C%20no%20text%2C%20a%20lone%20woman%20silhouette%20against%20a%20glowing%20city%20skyline%20at%20dusk%2C%20warm%20amber%20city%20lights%2C%20deep%20charcoal%20background%2C%20dramatic%20moody%20lighting%2C%20subtle%20film%20grain%2C%20elegant%20composition%2C%20high%20detail&width=600&height=900&seq=hs-p01&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20wide%20cityscape%20at%20night%20with%20glowing%20warm%20amber%20lights%20reflecting%20on%20wet%20streets%2C%20dramatic%20moody%20atmosphere%2C%20deep%20charcoal%20tones%2C%20film%20still%20aesthetic%2C%20no%20text%2C%20rich%20shadows%2C%20high%20detail&width=1600&height=900&seq=hs-b01&orientation=landscape',
    year: 2024,
    region: '国产',
    genres: ['剧情', '爱情'],
    rating: 8.6,
    cast: ['林清晏', '周牧之', '苏晚晴', '陈亦航'],
    director: '顾棠',
    duration: '128分钟',
    summary: '一座灯火不眠的城市里，两个被生活推着向前的人意外重逢。他们在深夜便利店的相遇，揭开了一段被时间掩埋的旧日约定。',
    updatedAt: '2024-10-12',
    popularity: 9820,
    badge: '热映',
    featured: true,
  },
  {
    id: 'm02',
    title: '暗夜追凶',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20vertical%20crime%20thriller%20poster%2C%20no%20text%2C%20detective%20in%20a%20long%20coat%20walking%20through%20foggy%20alley%2C%20single%20warm%20street%20lamp%20glow%2C%20deep%20charcoal%20background%2C%20high%20contrast%20moody%20lighting%2C%20film%20grain%2C%20tense%20atmosphere%2C%20high%20detail&width=600&height=900&seq=hs-p02&orientation=portrait',
    year: 2024,
    region: '国产',
    genres: ['犯罪', '悬疑', '惊悚'],
    rating: 8.9,
    cast: ['陆则言', '白知夏', '程野', '许南舟'],
    director: '韩沉',
    duration: '134分钟',
    summary: '连环案件沉寂七年后再度出现，退休刑警与年轻法医被迫重启调查。真相藏在每一个被忽略的细节里，而时间正在倒数。',
    updatedAt: '2024-10-08',
    popularity: 10450,
    badge: '高分',
    featured: true,
  },
  {
    id: 'm03',
    title: '沙海纪元',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20vertical%20sci-fi%20film%20poster%2C%20no%20text%2C%20lone%20traveler%20in%20flowing%20cloak%20standing%20on%20vast%20sand%20dunes%20under%20a%20huge%20golden%20sun%2C%20warm%20amber%20haze%2C%20deep%20charcoal%20sky%2C%20epic%20dramatic%20lighting%2C%20film%20grain%2C%20high%20detail&width=600&height=900&seq=hs-p03&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=epic%20desert%20landscape%20at%20golden%20hour%20with%20colossal%20sand%20dunes%20and%20warm%20amber%20sunlight%2C%20tiny%20silhouette%20of%20a%20traveler%2C%20deep%20charcoal%20sky%2C%20cinematic%20film%20still%2C%20dramatic%20scale%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=hs-b02&orientation=landscape',
    year: 2024,
    region: '欧美',
    genres: ['科幻', '冒险', '剧情'],
    rating: 8.4,
    cast: ['伊森·凯尔', '玛拉·维恩', '乔纳·布莱克'],
    director: '德里克·福特',
    duration: '146分钟',
    summary: '当星球的水源即将枯竭，一名年轻的测绘师踏上穿越沙海的旅程，去寻找传说中仍在流动的绿洲。',
    updatedAt: '2024-10-05',
    popularity: 8760,
    badge: '新片',
    featured: true,
  },
  {
    id: 'm04',
    title: '极速边缘',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20vertical%20action%20film%20poster%2C%20no%20text%2C%20sleek%20race%20car%20speeding%20through%20neon%20orange%20light%20trails%20at%20night%2C%20motion%20blur%2C%20deep%20charcoal%20background%2C%20dramatic%20high%20contrast%20lighting%2C%20film%20grain%2C%20energetic%20composition%2C%20high%20detail&width=600&height=900&seq=hs-p04&orientation=portrait',
    year: 2023,
    region: '欧美',
    genres: ['动作', '犯罪', '赛车'],
    rating: 7.8,
    cast: ['卢卡斯·雷', '妮娜·科瓦', '马库斯·邓'],
    director: '保罗·雷耶斯',
    duration: '118分钟',
    summary: '一支地下车队卷入跨国走私案，退役车手为了救回弟弟，重新坐上驾驶座，在城市与荒野之间飙出最后的胜负。',
    updatedAt: '2024-09-28',
    popularity: 7120,
  },
  {
    id: 'm05',
    title: '樱花之约',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20vertical%20romance%20film%20poster%2C%20no%20text%2C%20two%20figures%20standing%20under%20blooming%20cherry%20blossom%20trees%20at%20sunset%2C%20soft%20warm%20amber%20light%2C%20deep%20charcoal%20shadows%2C%20gentle%20nostalgic%20mood%2C%20film%20grain%2C%20elegant%20composition%2C%20high%20detail&width=600&height=900&seq=hs-p05&orientation=portrait',
    year: 2024,
    region: '日韩',
    genres: ['爱情', '剧情'],
    rating: 8.1,
    cast: ['高桥遥', '石川凛', '森下健'],
    director: '小林悠',
    duration: '126分钟',
    summary: '一封迟到了五年的信，让两个曾经错过的人重新站在同一棵樱花树下。有些约定的答案，需要走过一整个四季才能说出口。',
    updatedAt: '2024-10-01',
    popularity: 7930,
    badge: '口碑',
  },
  {
    id: 'm06',
    title: '深海孤影',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20vertical%20sci-fi%20horror%20film%20poster%2C%20no%20text%2C%20submersible%20descending%20into%20abyssal%20trench%20with%20faint%20amber%20lights%2C%20deep%20charcoal%20black%20water%2C%20eerie%20dramatic%20lighting%2C%20film%20grain%2C%20tense%20claustrophobic%20atmosphere%2C%20high%20detail&width=600&height=900&seq=hs-p06&orientation=portrait',
    year: 2023,
    region: '欧美',
    genres: ['科幻', '惊悚'],
    rating: 8.0,
    cast: ['艾丽西亚·曼', '汤姆·赫里', '王亦辰'],
    director: '娜奥米·里德',
    duration: '112分钟',
    summary: '一支深海勘探队在六千米海沟下失去通讯，唯一浮出水面的录音里，只剩下一段无法解释的敲击声。',
    updatedAt: '2024-09-20',
    popularity: 6680,
  },
  {
    id: 'm07',
    title: '江湖旧梦',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20vertical%20wuxia%20film%20poster%2C%20no%20text%2C%20martial%20artist%20in%20flowing%20dark%20robes%20with%20sword%20on%20misty%20mountain%20cliff%2C%20warm%20amber%20lantern%20glow%2C%20deep%20charcoal%20background%2C%20dramatic%20moody%20lighting%2C%20film%20grain%2C%20high%20detail&width=600&height=900&seq=hs-p07&orientation=portrait',
    year: 2024,
    region: '国产',
    genres: ['武侠', '动作', '古装'],
    rating: 8.7,
    cast: ['谢少陵', '温以宁', '裴长安', '江晚'],
    director: '叶孤城',
    duration: '137分钟',
    summary: '退隐十年的剑客因一封故人血书重出江湖。刀光背后，是一段关于背叛、赎罪与不肯熄灭的旧梦。',
    updatedAt: '2024-10-10',
    popularity: 9310,
    badge: '热映',
  },
  {
    id: 'm08',
    title: '午夜巴黎信笺',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20vertical%20romantic%20comedy%20film%20poster%2C%20no%20text%2C%20elegant%20vintage%20cafe%20on%20a%20cobblestone%20street%20at%20night%20with%20warm%20amber%20lights%2C%20deep%20charcoal%20shadows%2C%20charming%20nostalgic%20mood%2C%20film%20grain%2C%20refined%20composition%2C%20high%20detail&width=600&height=900&seq=hs-p08&orientation=portrait',
    year: 2023,
    region: '欧美',
    genres: ['爱情', '喜剧'],
    rating: 7.6,
    cast: ['克莱尔·杜邦', '雨果·马丁', '林知雨'],
    director: '索菲·罗兰',
    duration: '104分钟',
    summary: '一个落魄的翻译家误收到一沓陌生人的情书，为了物归原主，他走进了一场比小说更荒诞的巴黎夜游。',
    updatedAt: '2024-09-15',
    popularity: 5420,
  },
  {
    id: 't01',
    title: '星河长明',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20vertical%20historical%20drama%20poster%2C%20no%20text%2C%20regal%20figure%20in%20ornate%20robes%20standing%20before%20grand%20palace%20halls%20lit%20by%20warm%20amber%20lanterns%2C%20deep%20charcoal%20night%2C%20dramatic%20moody%20lighting%2C%20film%20grain%2C%20epic%20composition%2C%20high%20detail&width=600&height=900&seq=hs-p09&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=grand%20ancient%20palace%20courtyard%20at%20night%20illuminated%20by%20hundreds%20of%20warm%20amber%20lanterns%2C%20misty%20atmosphere%2C%20deep%20charcoal%20tones%2C%20cinematic%20film%20still%2C%20epic%20scale%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=hs-b03&orientation=landscape',
    year: 2024,
    region: '国产',
    genres: ['古装', '权谋', '剧情'],
    rating: 9.0,
    cast: ['沈知微', '萧景琰', '顾南枝', '陆廷之'],
    director: '柳无涯',
    duration: '单集45分钟',
    summary: '少年将军背负家族血仇入朝，在步步杀机的权力棋局中，与一位身世成谜的女官结成同盟，共守山河。',
    episodes: 40,
    updatedAt: '2024-10-14',
    popularity: 12400,
    badge: '热播',
    featured: true,
  },
  {
    id: 't02',
    title: '都市谜案',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20vertical%20crime%20series%20poster%2C%20no%20text%2C%20forensic%20investigator%20examining%20evidence%20under%20warm%20amber%20desk%20light%20in%20a%20dark%20room%2C%20deep%20charcoal%20background%2C%20moody%20high%20contrast%20lighting%2C%20film%20grain%2C%20suspenseful%20mood%2C%20high%20detail&width=600&height=900&seq=hs-p10&orientation=portrait',
    year: 2024,
    region: '国产',
    genres: ['悬疑', '犯罪', '刑侦'],
    rating: 8.8,
    cast: ['方叙白', '黎晚', '邢野', '许知遥'],
    director: '程亦鸣',
    duration: '单集42分钟',
    summary: '一组看似无关的都市案件，牵出同一个被抹去的名字。刑警队长与行为分析师联手，在城市褶皱里寻找真相。',
    episodes: 32,
    updatedAt: '2024-10-13',
    popularity: 11200,
    badge: '热播',
  },
  {
    id: 't03',
    title: '唐顿花园',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20vertical%20period%20drama%20poster%2C%20no%20text%2C%20elegant%20figure%20in%20vintage%20dress%20standing%20in%20a%20moonlit%20manor%20garden%2C%20warm%20amber%20window%20glow%2C%20deep%20charcoal%20shadows%2C%20refined%20nostalgic%20mood%2C%20film%20grain%2C%20high%20detail&width=600&height=900&seq=hs-p11&orientation=portrait',
    year: 2024,
    region: '欧美',
    genres: ['剧情', '历史'],
    rating: 8.2,
    cast: ['艾玛·沃森', '亨利·卡莱尔', '罗莎琳·格雷'],
    director: '爱德华·摩尔',
    duration: '单集50分钟',
    summary: '旧时代的庄园即将易主，一个家族三代人的秘密在花园深处慢慢浮现。每个人都在守护自己不愿承认的过去。',
    episodes: 24,
    updatedAt: '2024-10-06',
    popularity: 6890,
  },
  {
    id: 't04',
    title: '医者仁心',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20vertical%20medical%20drama%20poster%2C%20no%20text%2C%20surgeons%20in%20a%20dimly%20lit%20operating%20theater%20with%20warm%20amber%20task%20lights%2C%20deep%20charcoal%20background%2C%20dramatic%20moody%20lighting%2C%20film%20grain%2C%20intense%20hopeful%20mood%2C%20high%20detail&width=600&height=900&seq=hs-p12&orientation=portrait',
    year: 2023,
    region: '国产',
    genres: ['剧情', '医疗'],
    rating: 8.5,
    cast: ['俞明远', '沈昭', '万清', '何书宁'],
    director: '周允行',
    duration: '单集44分钟',
    summary: '急诊科里没有剧本，只有一次次与时间的赛跑。一群医生在生死之间，重新理解了「仁心」二字的分量。',
    episodes: 36,
    updatedAt: '2024-09-30',
    popularity: 8210,
    badge: '口碑',
  },
  {
    id: 't05',
    title: '东京恋歌',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20vertical%20romance%20series%20poster%2C%20no%20text%2C%20young%20couple%20on%20an%20empty%20train%20platform%20at%20night%20with%20warm%20amber%20lights%2C%20deep%20charcoal%20shadows%2C%20gentle%20melancholic%20mood%2C%20film%20grain%2C%20tender%20composition%2C%20high%20detail&width=600&height=900&seq=hs-p13&orientation=portrait',
    year: 2024,
    region: '日韩',
    genres: ['爱情', '都市'],
    rating: 7.9,
    cast: ['山崎奏', '新垣凛', '松本凉太'],
    director: '宫田淳',
    duration: '单集46分钟',
    summary: '深夜的电车、便利店的热咖啡、没有说完的告白。两个在城市里孤独生活的人，用一整季的四季，学会好好告别。',
    episodes: 12,
    updatedAt: '2024-10-02',
    popularity: 6310,
  },
  {
    id: 't06',
    title: '末日孤岛',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20vertical%20post-apocalyptic%20series%20poster%2C%20no%20text%2C%20lone%20survivor%20standing%20on%20a%20rocky%20cliff%20facing%20a%20stormy%20sea%2C%20faint%20warm%20amber%20horizon%20glow%2C%20deep%20charcoal%20storm%20clouds%2C%20dramatic%20epic%20lighting%2C%20film%20grain%2C%20high%20detail&width=600&height=900&seq=hs-p14&orientation=portrait',
    year: 2023,
    region: '欧美',
    genres: ['科幻', '惊悚', '冒险'],
    rating: 8.3,
    cast: ['奥利弗·斯通', '伊莎贝尔·诺', '戴米安·李'],
    director: '凯特·哈珀',
    duration: '单集52分钟',
    summary: '一场全球性的电磁风暴后，幸存者们被困在一座与世隔绝的孤岛。他们必须决定：重建文明，还是重温人性最原始的一面。',
    episodes: 18,
    updatedAt: '2024-09-25',
    popularity: 7480,
  },
  {
    id: 't07',
    title: '山河长歌',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20vertical%20epic%20historical%20drama%20poster%2C%20no%20text%2C%20armored%20general%20on%20horseback%20overlooking%20a%20vast%20misty%20mountain%20range%20at%20sunrise%2C%20warm%20amber%20light%2C%20deep%20charcoal%20tones%2C%20heroic%20dramatic%20lighting%2C%20film%20grain%2C%20high%20detail&width=600&height=900&seq=hs-p15&orientation=portrait',
    year: 2024,
    region: '国产',
    genres: ['古装', '战争', '剧情'],
    rating: 8.6,
    cast: ['萧决', '苏念安', '秦岳', '温初'],
    director: '陈望川',
    duration: '单集48分钟',
    summary: '乱世之中，一对师兄弟分属敌营。他们曾并肩立誓守护山河，却不得不在战场上，成为彼此最难面对的那个人。',
    episodes: 45,
    updatedAt: '2024-10-11',
    popularity: 9900,
    badge: '热播',
  },
  {
    id: 't08',
    title: '王国之争',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20vertical%20medieval%20drama%20poster%2C%20no%20text%2C%20crowned%20ruler%20holding%20a%20sword%20in%20a%20candlelit%20stone%20hall%2C%20warm%20amber%20flame%20glow%2C%20deep%20charcoal%20shadows%2C%20dramatic%20moody%20lighting%2C%20film%20grain%2C%20high%20detail&width=600&height=900&seq=hs-p16&orientation=portrait',
    year: 2024,
    region: '欧美',
    genres: ['剧情', '历史', '权谋'],
    rating: 8.4,
    cast: ['理查德·格雷', '艾琳娜·福', '詹姆斯·奥'],
    director: '玛格丽特·希尔',
    duration: '单集55分钟',
    summary: '老国王骤然离世，三个家族为一张王座展开博弈。婚姻、背叛与誓言，在烛光摇曳的宫廷里悄悄改写历史。',
    episodes: 20,
    updatedAt: '2024-10-07',
    popularity: 7760,
  },
  {
    id: 'v01',
    title: '奔跑吧，星光',
    type: 'variety',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20vertical%20variety%20show%20poster%2C%20no%20text%2C%20energetic%20group%20of%20young%20people%20running%20on%20a%20night%20city%20street%20with%20warm%20amber%20lights%2C%20deep%20charcoal%20background%2C%20vibrant%20playful%20lighting%2C%20film%20grain%2C%20dynamic%20composition%2C%20high%20detail&width=600&height=900&seq=hs-p17&orientation=portrait',
    year: 2024,
    region: '国产',
    genres: ['真人秀', '竞技'],
    rating: 8.0,
    cast: ['何星辰', '沈月', '陆嘉言', '小满', '阿KEN'],
    director: '王导',
    duration: '单期90分钟',
    summary: '八位嘉宾在每期不同城市里完成一场充满笑点与热血的限时挑战，输赢之外，更是一场关于默契的旅行。',
    episodes: 12,
    updatedAt: '2024-10-13',
    popularity: 8400,
    badge: '热播',
  },
  {
    id: 'v02',
    title: '环球美食纪',
    type: 'variety',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20vertical%20food%20documentary%20poster%2C%20no%20text%2C%20chef%20plating%20an%20elegant%20dish%20in%20a%20warm%20amber%20lit%20rustic%20kitchen%2C%20deep%20charcoal%20background%2C%20appetizing%20warm%20lighting%2C%20film%20grain%2C%20rich%20textures%2C%20high%20detail&width=600&height=900&seq=hs-p18&orientation=portrait',
    year: 2024,
    region: '国产',
    genres: ['美食', '纪实'],
    rating: 8.6,
    cast: ['主厨·阿墨', '林晚', '苏扬'],
    director: '李味',
    duration: '单期45分钟',
    summary: '从街边小摊到米其林后厨，镜头跟随三位厨师走遍十二座城市，寻找藏在烟火气里的、最动人的味道。',
    episodes: 12,
    updatedAt: '2024-10-09',
    popularity: 7950,
  },
  {
    id: 'v03',
    title: '音乐无界',
    type: 'variety',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20vertical%20music%20show%20poster%2C%20no%20text%2C%20singer%20silhouette%20on%20stage%20surrounded%20by%20warm%20amber%20spotlights%20and%20haze%2C%20deep%20charcoal%20background%2C%20dramatic%20concert%20lighting%2C%20film%20grain%2C%20emotional%20atmosphere%2C%20high%20detail&width=600&height=900&seq=hs-p19&orientation=portrait',
    year: 2024,
    region: '国产',
    genres: ['音乐', '现场'],
    rating: 8.3,
    cast: ['周听澜', '陈屿', '安琪', '老猫'],
    director: '许声',
    duration: '单期60分钟',
    summary: '每一期邀请不同风格的歌手同台改编经典。当民谣遇上电子、戏曲碰撞摇滚，音乐的可能性就此被重新打开。',
    episodes: 10,
    updatedAt: '2024-10-08',
    popularity: 7180,
  },
  {
    id: 'v04',
    title: '推理之夜',
    type: 'variety',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20vertical%20mystery%20game%20show%20poster%2C%20no%20text%2C%20group%20of%20players%20around%20a%20dim%20table%20lit%20by%20a%20single%20warm%20amber%20lamp%20with%20clues%20scattered%2C%20deep%20charcoal%20shadows%2C%20suspenseful%20moody%20lighting%2C%20film%20grain%2C%20high%20detail&width=600&height=900&seq=hs-p20&orientation=portrait',
    year: 2023,
    region: '国产',
    genres: ['推理', '真人秀'],
    rating: 8.5,
    cast: ['柯言', '林澈', '白薇', '大熊'],
    director: '谜导',
    duration: '单期75分钟',
    summary: '六位玩家被困在一桩桩精心设计的谜局中，每个人都有可能说谎。找出真凶，或成为被误判的那个人。',
    episodes: 14,
    updatedAt: '2024-09-29',
    popularity: 7620,
    badge: '口碑',
  },
  {
    id: 'v05',
    title: '极限挑战营',
    type: 'variety',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20vertical%20outdoor%20adventure%20show%20poster%2C%20no%20text%2C%20contestants%20climbing%20a%20mountain%20ridge%20at%20golden%20sunrise%20with%20warm%20amber%20light%2C%20deep%20charcoal%20shadows%2C%20epic%20dramatic%20lighting%2C%20film%20grain%2C%20energetic%20atmosphere%2C%20high%20detail&width=600&height=900&seq=hs-p21&orientation=portrait',
    year: 2024,
    region: '国产',
    genres: ['户外', '竞技'],
    rating: 7.8,
    cast: ['石头', '阿泽', '娜娜', '高远'],
    director: '峰导',
    duration: '单期80分钟',
    summary: '翻山、渡河、荒野求生——嘉宾们在真实自然中接受体能与意志的双重考验，也重新认识了同伴与自己。',
    episodes: 12,
    updatedAt: '2024-10-04',
    popularity: 6240,
  },
  {
    id: 'v06',
    title: '笑对人生',
    type: 'variety',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20vertical%20stand-up%20comedy%20show%20poster%2C%20no%20text%2C%20comedian%20performing%20under%20a%20single%20warm%20amber%20stage%20spotlight%20with%20microphone%2C%20deep%20charcoal%20background%2C%20dramatic%20moody%20lighting%2C%20film%20grain%2C%20warm%20humorous%20mood%2C%20high%20detail&width=600&height=900&seq=hs-p22&orientation=portrait',
    year: 2023,
    region: '国产',
    genres: ['喜剧', '脱口秀'],
    rating: 8.1,
    cast: ['小北', '阿宇', '陈默', '莉莉'],
    director: '笑导',
    duration: '单期50分钟',
    summary: '一群普通人把生活里的窘迫讲成段子。笑着笑着你会发现，那些最难的日子，其实也值得被认真对待。',
    episodes: 16,
    updatedAt: '2024-09-26',
    popularity: 6790,
  },
  {
    id: 'v07',
    title: '唱作人之声',
    type: 'variety',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20vertical%20music%20competition%20poster%2C%20no%20text%2C%20songwriter%20with%20guitar%20in%20a%20warm%20amber%20lit%20recording%20studio%20surrounded%20by%20faint%20light%20streaks%2C%20deep%20charcoal%20background%2C%20intimate%20moody%20lighting%2C%20film%20grain%2C%20high%20detail&width=600&height=900&seq=hs-p23&orientation=portrait',
    year: 2024,
    region: '国产',
    genres: ['音乐', '选秀'],
    rating: 8.4,
    cast: ['许诺', '阿洛', '子墨', '晴天'],
    director: '律导',
    duration: '单期65分钟',
    summary: '他们既是演唱者也是创作者，每一首歌都从零开始。舞台之上没有翻唱捷径，只有把自己的故事写成旋律。',
    episodes: 12,
    updatedAt: '2024-10-12',
    popularity: 8120,
    badge: '热播',
  },
  {
    id: 'v08',
    title: '旅行的意义',
    type: 'variety',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20vertical%20travel%20show%20poster%2C%20no%20text%2C%20traveler%20with%20backpack%20on%20a%20quiet%20coastal%20road%20at%20golden%20sunset%2C%20warm%20amber%20light%20over%20the%20sea%2C%20deep%20charcoal%20shadows%2C%20serene%20cinematic%20mood%2C%20film%20grain%2C%20high%20detail&width=600&height=900&seq=hs-p24&orientation=portrait',
    year: 2024,
    region: '日韩',
    genres: ['旅行', '纪实'],
    rating: 8.2,
    cast: ['凉子', '浩二', '小雨'],
    director: '竹内纪',
    duration: '单期40分钟',
    summary: '没有行程表，也没有必去景点。三个人带着一台相机出发，慢下来，去遇见那些攻略里没有写下的风景。',
    episodes: 10,
    updatedAt: '2024-10-03',
    popularity: 5870,
  },
];

export const featuredIds = ['m02', 't01', 'm01', 'v01', 'm07'];